import { mapGetters } from 'vuex'

export default {
  methods: {
    validateLatinCharacter (val) {
      let charset = window.ENV_VARIABLES.EU_LATIN_TEXT_CHARSET
      let reg = new RegExp(`[^${charset}]`, 'gi')
      return val.target.value.replace(reg, '')
    },
    getMetaInfoMixin ({defaultMetaInfo, sharedImg}) {
      let meta = this.getMetaInfo.value
      let img = sharedImg || document.location.origin + '/webapp/images/default-shared.png'
      let metaObj = {}
      if (meta) {
        metaObj = {
          title: meta.meta_title,
          meta: [
            {itemprop: 'name', content: meta.meta_title},
            {name: 'og:title', content: meta.opengraph_title || meta.meta_title},
            {name: 'description', content: meta.meta_description},
            {itemprop: 'description', content: meta.meta_description},
            {name: 'og:description', content: meta.opengraph_description || meta.meta_description},
            {name: 'image', content: img},
            {itemprop: 'image', content: img},
            {name: 'og:image', content: meta.opengraph_image || img},
            {vmid: 'robots', name: 'robots', content: meta.meta_robots_tags},
            {name: 'og:type', content: meta.opengraph_type},
            {name: 'og:url', content: meta.opengraph_url || document.location.origin + document.location.pathname},
            {name: 'og:site_name', content: window.ENV_VARIABLES.OPENGRAPH_SITE_NAME[this.getLanguage] || window.ENV_VARIABLES.OPENGRAPH_SITE_NAME.en}
          ]
        }
        if (window.ENV_VARIABLES.META_FACEBOOK_APP_ID) {
          metaObj.meta.push({name: 'fb:app_id', content: window.ENV_VARIABLES.META_FACEBOOK_APP_ID})
        }
        if (defaultMetaInfo.link) {
          defaultMetaInfo.link.map(x => {
            if (x.rel === 'canonical') {
              x.href = document.location.origin + document.location.pathname
            }
          })
          metaObj.link = defaultMetaInfo.link
        }
        if (defaultMetaInfo.script) {
          metaObj.script = defaultMetaInfo.script
        }
      } else {
        metaObj = {
          title: defaultMetaInfo.title,
          meta: [
            {itemprop: 'name', content: defaultMetaInfo.title},
            {name: 'og:title', content: defaultMetaInfo.title},
            {name: 'image', content: img},
            {itemprop: 'image', content: img},
            {name: 'og:image', content: img},
            {name: 'og:type', content: 'article'},
            {name: 'og:url', content: document.location.origin + document.location.pathname},
            {name: 'og:site_name', content: window.ENV_VARIABLES.OPENGRAPH_SITE_NAME[this.getLanguage] || window.ENV_VARIABLES.OPENGRAPH_SITE_NAME.en}
          ]
        }
        if (window.ENV_VARIABLES.META_FACEBOOK_APP_ID) {
          metaObj.meta.push({name: 'fb:app_id', content: window.ENV_VARIABLES.META_FACEBOOK_APP_ID})
        }
        if (defaultMetaInfo.link) {
          defaultMetaInfo.link.map(x => {
            if (x.rel === 'canonical') {
              x.href = document.location.origin + document.location.pathname
            }
          })
          metaObj.link = defaultMetaInfo.link
        }
        if (defaultMetaInfo.script) {
          metaObj.script = defaultMetaInfo.script
        }
      }
      return metaObj
    }
  },
  computed: {
    ...mapGetters([
      'getMetaInfo',
      'getLanguage'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js